import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { styled, alpha } from '@mui/material/styles';
import { Alert, Snackbar, ThemeProvider, CircularProgress, Backdrop } from '@mui/material';
import InputBase from '@mui/material/InputBase';
import Menu from '../speedDial';
import theme from '../../theme';
import { useState, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useLocation } from 'react-router-dom';
import Fab from '@mui/material/Fab';
import { profileMenu, routeNameMapping } from './constants';
import './style.scss';
import { KeyboardBackspace } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { useConnect } from '@stacks/connect-react';
import CreateChimeModal from '../../components/modal/CreateChimeModal';
import BnsWarningModal from '../../components/modal/BnsWarningModal';
import ConfirmModal from '../../components/modal/ConfirmModal';
import UserContractDeployModal from '../modal/UserContractDeployModal';
import { validateUsersContract } from '../../services/stacks';
import { MdAdd, MdClose, MdOutlinePostAdd } from 'react-icons/md';
import { TbBellPlus, TbBell } from 'react-icons/tb';
import { getBlockDifference } from '../../services/chime';

const Header = ({ isAuthenticated, logout }) => {
  // const Search = styled('div')(({ theme }) => ({
  //   display: 'flex',
  //   alignItems: 'center',
  //   flexGrow: 1,
  //   backgroundColor: alpha(theme.palette.common.white, 0.4),
  //   borderRadius: theme.shape.borderRadius,
  //   '&:hover': {
  //     backgroundColor: alpha(theme.palette.common.white, 0.6),
  //   },
  //   padding: '0 10px',
  // }));


  // const SearchIconWrapper = styled('div')(({ theme }) => ({
  //   padding: theme.spacing(0, 2),
  //   height: '100%',
  //   position: 'absolute',
  //   pointerEvents: 'none',
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  // }));

  // const StyledInputBase = styled(InputBase)(({ theme }) => ({
  //   color: 'inherit',
  //   '& .MuiInputBase-input': {
  //     padding: theme.spacing(1, 1, 1, 0),
  //     // vertical padding + font size from searchIcon
  //     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
  //     transition: theme.transitions.create('width'),
  //     width: '100%',
  //     [theme.breakpoints.up('sm')]: {
  //       width: '16ch',
  //       '&:focus': {
  //         width: '50ch',
  //       },
  //     },
  //   },
  // }));

  let currentPage = routeNameMapping[window.location.pathname] || 'Home';
  const pathname = window.location.pathname;
  if (/^\/(ST|SP).*|\./.test(pathname)) {
    currentPage = 'Profile';
  }
  if (pathname.includes('muted')) {
    currentPage = 'Muted';
  }
  if (pathname.includes('history')) {
    currentPage = 'History';
  }
  if (pathname.includes('launch')) {
    currentPage = 'Launch';
  }
  if (pathname.includes('extensions')) {
    currentPage = 'Extensions';
  }
  if (pathname.includes('mining')) {
    currentPage = 'Mining';
  }
  if (pathname.includes('stacking')) {
    currentPage = 'Stacking';
  }
  if (pathname.includes('settings')) {
    currentPage = 'Settings';
  }
  if (pathname.includes('following')) {
    currentPage = 'Following';
  }
  if (pathname.includes('exhibit')) {
    currentPage = 'Exhibit';
  }

  const [isProfileMenuOpen, toggleProfileMenu] = useState(false);
  const [showCreateChimeModal, setShowCreateChimeModal] = useState(false);
  const [showUserContractDeployModal, setShowUserContractDeployModal] = useState(false);
  const [userContractStatus, setUserContractStatus] = useState('');
  const [showBnsError, setShowBnsError] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [txId, setTxId] = useState('');
  const [createChimeBtn, setCreateChimeBtn] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [showMenu, setShowMenu] = useState(true);
  const [showSearch, setShowSearch] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isFabMenuOpen, setFabMenuOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { doOpenAuth } = useConnect();

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
  };

  const updateRoute = useCallback(
    (link) => {
      if (link.value === 'signOut') {
        logout();
        return;
      }

      if (currentPage === 'Profile' && link.value.includes('profile')) {
        navigate(link.value, {});
        window.location.reload();
        return;
      }
      navigate(link.value, {});
    },
    [currentPage, navigate, logout]
  );

  const onSearch = useCallback(
    (event) => {
      event.preventDefault();
      const val = event.target[0].value;
      navigate(`/${val}`);
      if (currentPage === 'Profile') window.location.reload();
    },
    [currentPage, navigate]
  );

  const toggleFabMenu = () => {
    setFabMenuOpen((prevOpen) => !prevOpen);
  };

  const handleCreateChimeClick = () => {
    handleUserContractCheck();
    setFabMenuOpen(false);
  };

  const handleExhibitClick = () => {
    navigate('/exhibit');
    setFabMenuOpen(false);
  };

  const handleUserContractCheck = async () => {
    setCreateChimeBtn(true);
    setLoading(true); // Set loading to true at the beginning

    const blockChecker = await getBlockDifference();

    if (!blockChecker) {
      const { state, txId } = await validateUsersContract();
      console.log({ state, txId });
      setTxId(txId);
      setUserContractStatus(state);
      switch (state) {
        case true: // deployed and activated
          setShowCreateChimeModal(true);
          setShowUserContractDeployModal(false);
          break;
        case false: // onlyDeployed - needs activated
          setShowCreateChimeModal(false);
          setShowUserContractDeployModal(true);
          break;
        case 'mempool':
          setShowCreateChimeModal(false);
          setShowUserContractDeployModal(true);
          break;
        case 'abort_by_post_condition':
        case 'abort_by_response':
          setShowCreateChimeModal(false);
          setShowUserContractDeployModal(true);
          break;
        default:
          setShowCreateChimeModal(false);
          setShowUserContractDeployModal(true);
          break;
      }
    } else {
      setErrorMsg('Your last mined block is still pending. Retry your operation after your last mined block has confirmed.');
      setShowCreateChimeModal(false);
      setOpenSnackBar(true);
    }

    setCreateChimeBtn(false);
    setLoading(false); // Set loading to false at the end
  };

  // Hide Fab on these pages
  useEffect(() => {
    const pathname = location.pathname;
    const hideFab =
      pathname === '/muted' ||
      pathname === '/mining' ||
      pathname === '/stacking' ||
      pathname === '/launch' ||
      pathname === '/exhibit' ||
      pathname === '/extensions' ||
      pathname === '/history' ||
      pathname === '/settings' ||
      pathname === '/following' ||
      /^\/(ST|SP).*|\./.test(pathname);
      
    setShowButton(!hideFab);
  }, [location]);

  // Hide Menu on these pages
  useEffect(() => {
    const pathname = location.pathname;
    const hideMenu =
      pathname === '/muted' ||
      pathname === '/history' ||
      pathname === '/launch' ||
      pathname === '/exhibit' ||
      currentPage === 'Exhibit' ||
      pathname === '/extensions' ||
      pathname === '/mining' ||
      pathname === '/stacking' ||
      pathname === '/settings' ||
      pathname === '/following' ||
      /^\/(ST|SP).*|\./.test(pathname);

    setShowMenu(!hideMenu);
  }, [location, currentPage]);

  // Hide Search on these pages
  useEffect(() => {
    const pathname = location.pathname;
    const hideSearch =
      pathname === '/muted' ||
      pathname === '/mining' ||
      pathname === '/stacking' ||
      pathname === '/launch' ||
      pathname === '/exhibit' ||
      pathname === '/extensions' ||
      pathname === '/history' ||
      pathname === '/settings' ||
      pathname === '/following';
      /^\/(ST|SP).*|\./.test(pathname);

    setShowSearch(!hideSearch);
  }, [location]);

  return (
    <div className="center">
      <ThemeProvider theme={theme}>
        <Box sx={{ flexGrow: 1 }}>
          <AppBar  position="static" className={'header'} color="primary" id="navbar">
            <Toolbar id="navtools">
              {isAuthenticated && currentPage === 'Profile' && (
                <KeyboardBackspace sx={{ cursor: 'pointer' }} fontSize="large" onClick={() => updateRoute({ value: '/' })}/>
              )}
              {isAuthenticated && currentPage === 'History' && (
                <KeyboardBackspace sx={{ cursor: 'pointer' }} fontSize="large" onClick={() => updateRoute({ value: '/' })}/>
              )}
              {isAuthenticated && currentPage === 'Launch' && (
                <KeyboardBackspace sx={{ cursor: 'pointer' }} fontSize="large" onClick={() => updateRoute({ value: '/' })}/>
              )}
              {isAuthenticated && currentPage === 'Exhibit' && (
                <KeyboardBackspace sx={{ cursor: 'pointer' }} fontSize="large" onClick={() => updateRoute({ value: '/' })}/>
              )}
              {isAuthenticated && currentPage === 'Extensions' && (
                <KeyboardBackspace sx={{ cursor: 'pointer' }} fontSize="large" onClick={() => updateRoute({ value: '/' })}/>
              )}
              {isAuthenticated &&
                (currentPage === 'Mining' || currentPage === 'Stacking') && (
                  <KeyboardBackspace sx={{ cursor: 'pointer' }} fontSize="large" onClick={() => updateRoute({ value: '/' })}/>
                )}
              {isAuthenticated && currentPage === 'Settings' && (
                <KeyboardBackspace sx={{ cursor: 'pointer' }} fontSize="large" onClick={() => updateRoute({ value: '/' })}/>
              )}
              {isAuthenticated && currentPage === 'Following' && (
                <KeyboardBackspace sx={{ cursor: 'pointer' }} fontSize="large" onClick={() => updateRoute({ value: '/' })}/>
              )}
              {isAuthenticated && currentPage === 'Muted' && (
                <KeyboardBackspace sx={{ cursor: 'pointer' }} fontSize="large" onClick={() => updateRoute({ value: '/settings' })}/>
              )}

              {!isAuthenticated && <Button onClick={() => doOpenAuth()} color="inherit">Connect</Button>}

              {isAuthenticated && (
                <>
                  {showMenu && (
                    <div id="profileMenu" className="profilemenu">
                      <Menu 
                        id="burger"
                        type={profileMenu.icon}
                        actions={profileMenu.options}
                        open={isProfileMenuOpen}
                        toggleState={() => toggleProfileMenu(!isProfileMenuOpen)}
                        onActionClickhandler={updateRoute}
                      />
                    </div>
                  )}
                  {showButton && (
                    <div id="fabMenu" className="fabmenu">
                      {isFabMenuOpen && (
                        <div className="fabMenuItems">
                          <Fab onClick={handleCreateChimeClick} size="small" style={{ marginBottom: '8px' }}>
                            <TbBellPlus id="fabOptionIcon" />
                          </Fab>
                          <Fab onClick={handleExhibitClick} size="small" style={{ marginBottom: '8px' }}>
                            <MdOutlinePostAdd id="fabOptionIcon" />
                          </Fab>
                        </div>
                      )}
                      <Fab style={{ marginTop: 1 }} id="fabbutton" size="large" onClick={toggleFabMenu} disabled={createChimeBtn}>
                        {isFabMenuOpen ? (
                          <MdClose id="fabicon" />
                        ) : (
                          <MdAdd id="fabicon" />
                        )}
                      </Fab>
                    </div>
                  )}
                </>
              )}

              {showSearch && (
                <form id="search-form" onSubmit={onSearch}>
                  <div id="search-field">
                    <div id="search-icon-wrapper">
                      <SearchIcon id="search-icon" />
                    </div>
                    <input id="search-input" placeholder="BNS, Address, or TX" inputprops={{ 'aria-label': 'search users, enter stx address or username' }}/>
                  </div>
                </form>
              )}

              {isAuthenticated && <div id="notificationBtn"><TbBell id="notificationIcon" /></div>}

            </Toolbar>
          </AppBar>
        </Box>
      </ThemeProvider>

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress />
      </Backdrop>

      {openSnackBar && (
        <Snackbar open={openSnackBar} autoHideDuration={10000} onClose={handleCloseSnackBar}>
          <Alert onClose={handleCloseSnackBar} severity="error" sx={{ width: '100%' }}>
            {errorMsg}
          </Alert>
        </Snackbar>
      )}
      {showUserContractDeployModal && (
        <UserContractDeployModal
          show={showUserContractDeployModal}
          setShow={setShowUserContractDeployModal}
          txId={txId}
          setTx_Id={setTxId}
          setTxId={setTxId}
          userContractStatus={userContractStatus}
          setUserContractStatus={setUserContractStatus}
          openConfirmModal={setOpenConfirmModal}
        />
      )}
      {showCreateChimeModal && (
        <CreateChimeModal
          setOpenConfirmModal={setOpenConfirmModal}
          show={showCreateChimeModal}
          setShow={setShowCreateChimeModal}
          close={() => setShowCreateChimeModal(false)}
          showBnsError={() => setShowBnsError(true)}
        />
      )}
      {openConfirmModal && (
        <ConfirmModal
          txId={txId}
          show={openConfirmModal}
          setShow={setOpenConfirmModal}
          close={() => setOpenConfirmModal(false)}
        />
      )}
      {showBnsError && (
        <BnsWarningModal
          show={showBnsError}
          close={() => setShowBnsError(false)}
        />
      )}
    </div>
  );
};

export default Header;
